import classNames from "classnames";
import React, { FC } from "react";
import ListItem, { ListItemLayout } from ".";

type ImageListItemProps = {
  src?: string;
  imageStyle?: string | string[];
  textStyle?: string | string[];
  text: string;
  layout?: ListItemLayout;
  link?: string;
  prefixDomain?: boolean;
  breakWord?: boolean;
};

const ImageListItem: FC<ImageListItemProps> = ({
  src,
  text,
  imageStyle,
  textStyle,
  layout = ListItemLayout["left"],
  link,
  prefixDomain = true,
  breakWord = false,
}) => {
  const createUrl = (src: string) =>
    prefixDomain ? `${process.env.NEXT_PUBLIC_ASSET_SERVER_URL}${src}` : src;

  return (
    <ListItem
      imageStyle={classNames(imageStyle)}
      textStyle={classNames(textStyle)}
      layout={layout}
      src={src ? createUrl(src) : ""}
      text={text}
      link={link}
      breakWord={breakWord}
    />
  );
};

export default ImageListItem;
